import { openURL } from 'expo-linking'
import { Platform } from 'react-native'

import { getWhatsAppUrl } from '@/src/features/share/utils/getWhatsAppUrl'
import { UTM } from '@/src/general/constants/utm'
import { useUrlBuilder } from '@/src/general/hooks/useUrlBuilder'
import { GTM } from '@/src/general/utils/gtm'
import { EVENTS, TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { useRoutes } from '@/src/general/utils/routes'

import { usePublicationShareStore } from '../../stores/usePublicationShareStore'
import type { TPublicationToShare } from '../components/PublicationShareModal'

export const useSharePublication = () => {
  const urlBuilder = useUrlBuilder()
  const { routes } = useRoutes()
  const open = usePublicationShareStore((state) => state.open)

  const share = (publication: TPublicationToShare, trackingSource: TRACKING_SOURCE) => open(publication, trackingSource)

  const shareOnWhatsApp = (publication: TPublicationToShare, trackingSource: TRACKING_SOURCE) => {
    GTM.sendEvent({ event: EVENTS.PARTAGE_WHATSAPP }, { trackingSource })
    const publicationLinkUrl = urlBuilder.withUTM({
      route: routes.publication({ id: publication.id, slug: publication.slug, source: TRACKING_SOURCE.SHARE_LINK }),
      campaign: UTM.CAMPAIGN.COMMUNITY(publication.community.id),
    })
    const whatsAppUrl = getWhatsAppUrl(publicationLinkUrl)

    if (Platform.OS === 'web') {
      window.open(whatsAppUrl, '_blank')
    } else {
      openURL(whatsAppUrl)
    }
  }

  return { share, shareOnWhatsApp }
}
